<template>
  <div>
    <div class="sp-60px"></div>
    <Header />
    <Player
      v-if="this.store.state.list.ids.length!=0"
    />

    <router-view />
    <div class="sp-150px"></div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import Header from "@/components/Header.vue";
import Player from "@/components/Player.vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "App",
  components: { Header, Player },
  setup() {
    const store = useStore();
    return { store };
  },
});
</script>

<style>
.sp-60px {
  height: 50px;
}
.sp-150px {
  height: 150px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
